module.exports = __webpack_public_path__ + "static/media/register-button.ed777e6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register-button.svg
// module id = 372
// module chunks = 0